import Logger from '../Logger';

const logger = new Logger('locales');
const list = [
	{
		name   : '简体中文',
		file   : 'cn',
		locale: ['cn', 'zh', 'zh-cn']
	}, // 语言_地域.字符集
	{
		name: 'English',
		file: 'en',
		locale: ['en', 'en-en', 'en-us']
	}
];

/**
 * 系统语言
 */
export const detect = () => {

	const localeFull = (navigator.language || navigator.browserLanguage).toLowerCase();
	// const localeCountry = localeFull.split(/[-_]/)[0];
	// const localeRegion = localeFull.split(/[-_]/)[1] || null;
	logger.debug('detect [localeFull:"%o"]', localeFull);
	return localeFull;
};

export const getList = () => list;

export const loadOne = (lang = 'zh-cn') => {

	let res = {}; // 语言库

	try {

		res = list.filter((item) => item.locale.includes(lang))[0];

		logger.debug('loadOne [locale:"%o",res:"%o"]', lang, res);

		res.messages = require(`./${res.file}`);

	} catch(error) {

		logger.error('loadOne [error:"%o"]', error);

		res = list.filter((item) => item.locale.includes('en'))[0];
		res.messages = require(`./${res.file}`);
	}

	return res;
};
